var React = require('react');

function GEO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.1223 0.507812C7.08831 0.507812 0.570312 6.56081 0.570312 14.0188C0.570312 24.5288 15.1223 42.5468 15.1223 42.5468C15.1223 42.5468 29.6703 24.5288 29.6703 14.0188C29.6703 6.56081 23.1563 0.507812 15.1223 0.507812ZM15.1223 19.7988C14.185 19.7988 13.2688 19.5209 12.4895 19.0001C11.7101 18.4794 11.1027 17.7393 10.744 16.8734C10.3854 16.0074 10.2915 15.0546 10.4744 14.1353C10.6572 13.216 11.1086 12.3716 11.7713 11.7088C12.4341 11.0461 13.2785 10.5947 14.1978 10.4119C15.1171 10.229 16.0699 10.3229 16.9359 10.6815C17.8018 11.0402 18.5419 11.6476 19.0627 12.427C19.5834 13.2063 19.8613 14.1225 19.8613 15.0598C19.861 16.3166 19.3617 17.5218 18.473 18.4105C17.5843 19.2992 16.3791 19.7985 15.1223 19.7988Z","fill":"#2CD0DB"}));
}

GEO.defaultProps = {"width":"30","height":"43","viewBox":"0 0 30 43","fill":"none"};

module.exports = GEO;

GEO.default = GEO;
